import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageIndex } from "../../models";
import { successfulLogin } from "../../auth/authDataSlice";
import { TradingDataFilter } from "./types";

type TradingDataPageState = {
  index: PageIndex;
  filter: TradingDataFilter;
};

export const initialState: TradingDataPageState = {
  index: {
    itemsPerPage: 20,
    pageNumber: 0,
  },
  filter: {
    datefrom: new Date().toISOString(),
    dateto: new Date().toISOString(),
    reportDate: new Date().toISOString(),
  },
};

const name = "tradingData";

const tradingDataSlice = createSlice({
  name,
  initialState,
  reducers: {
    setTradingDateIndex: (state, action: PayloadAction<PageIndex>) => ({
      ...state,
      index: action.payload,
    }),
    resetTradingDateIdices: (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }),
    setFilter: (state, action: PayloadAction<TradingDataFilter>) => ({
      ...state,
      filter: action.payload,
    }),
    removeFilter: (state, action: PayloadAction<keyof TradingDataFilter>) => ({
      ...state,
      filter: {
        ...state.filter,
        [action.payload]: undefined,
      },
    }),
    setReportData: (state, action: PayloadAction<string>) => ({
      ...state,
      filter: {...state.filter,
        reportDate: action.payload,
        datefrom: action.payload,
        dateto: action.payload,
          },
    }),

  },
  
  extraReducers: (builder) => {
    builder.addCase(successfulLogin, (state) => ({
      ...state,
      index: {
        itemsPerPage: state.index.itemsPerPage,
        pageNumber: initialState.index.pageNumber,
      },
    }));
  },
});

export const {
  setTradingDateIndex,
  resetTradingDateIdices,
  setFilter,
  removeFilter,
  setReportData,
} = tradingDataSlice.actions;

export default tradingDataSlice.reducer;
